/* [Modified by Codex at 2026-10-12] 让原生变体驱动定制功能并延后执行，避免阻塞页面解析 */
(() => {
  'use strict';

  const SIZE_DATA = [
    { size: 'US00', bust: 31, waist: 23, hips: 34.5, hollow: 56 },
    { size: 'US0', bust: 32, waist: 24, hips: 35.5, hollow: 57 },
    { size: 'US2', bust: 33, waist: 25, hips: 36.5, hollow: 57 },
    { size: 'US4', bust: 34, waist: 26, hips: 37.5, hollow: 58 },
    { size: 'US6', bust: 35, waist: 27, hips: 38.5, hollow: 58 },
    { size: 'US8', bust: 36, waist: 28, hips: 39.5, hollow: 59 },
    { size: 'US10', bust: 37.5, waist: 29.5, hips: 41, hollow: 59 },
    { size: 'US12', bust: 39, waist: 31, hips: 43, hollow: 60 },
    { size: 'US14', bust: 41, waist: 33, hips: 45, hollow: 60 },
    { size: 'US16', bust: 43, waist: 35, hips: 47, hollow: 61 },
  ];
  const SIZE_SYSTEM_LABELS = {
    US00: { US: 'US-00', 'UK/AU': 'UK/AU-2', EUR: 'EUR-30' },
    US0: { US: 'US-0', 'UK/AU': 'UK/AU-4', EUR: 'EUR-32' },
    US2: { US: 'US-2', 'UK/AU': 'UK/AU-6', EUR: 'EUR-34' },
    US4: { US: 'US-4', 'UK/AU': 'UK/AU-8', EUR: 'EUR-36' },
    US6: { US: 'US-6', 'UK/AU': 'UK/AU-10', EUR: 'EUR-38' },
    US8: { US: 'US-8', 'UK/AU': 'UK/AU-12', EUR: 'EUR-40' },
    US10: { US: 'US-10', 'UK/AU': 'UK/AU-14', EUR: 'EUR-42' },
    US12: { US: 'US-12', 'UK/AU': 'UK/AU-16', EUR: 'EUR-44' },
    US14: { US: 'US-14', 'UK/AU': 'UK/AU-18', EUR: 'EUR-46' },
    US16: { US: 'US-16', 'UK/AU': 'UK/AU-20', EUR: 'EUR-48' },
  };
  const CUSTOM_RANGES = {
    bust: { min: 27, max: 67 },
    waist: { min: 22, max: 70 },
    hips: { min: 30, max: 74.5 },
    hollow: { min: 31, max: 90 },
    height: { min: 54, max: 100 },
  };
  const FIELD_TIPS = {
    bust: 'Bust*: Wear the bra you will be wearing with the dress, and pull the tape across the fullest part of the bust.',
    waist: 'Waist*: Measure around the smallest part of your natural waistline.',
    hips: 'Hips*: Measure around the fullest part of your hips.',
    hollow: 'Hollow To Floor*: Measure from the hollow of your throat to the floor.',
    height: 'Height (Bare Foot)*: Stand straight with bare feet together and measure from the top of the head to the floor.',
    extra: 'Extra Length: Add extra length if needed for heels or personal preference.',
  };
  const MEASURES = ['bust', 'waist', 'hips', 'hollow', 'height'];
  // [Modified by Codex at 2026-10-26] 使用通用提示兼容新旧定制颜色入口
  const MORE_COLOR_MESSAGE = 'Please choose a specific custom color below!';
  // [End]
  const CUSTOM_SIZE_MESSAGE = 'When selecting the "CUSTOM SIZE" option, please provide accurate measurements for bust, waist, hips, and Hollow To Floor!';
  const normalize = (value) => String(value || '').trim().toLowerCase();

  class ProductVariantExtras extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.sectionRoot = this.closest('.bls__template-product');
      this.native = this.querySelector('variant-selects');
      this.form = document.getElementById(`product-form-${this.dataset.sectionId}`);
      this.ready = false;
      this.currentUnit = this.querySelector('.unit.active')?.dataset.unit || 'in';
      this.currentSizeSystem = this.querySelector('.size-system-radio:checked')?.value || 'US';
      this.lastSize = undefined;
      // [Modified by Codex at 2026-10-12] 记录尺码选项是否存在，避免遗留表格错误显示
      this.lastHasSize = undefined;
      // [End]
      this.lastColor = undefined;

      this.form?.addEventListener('submit', (event) => {
        this.syncHiddenFields();
        if (!this.ready || !this.getCurrentVariant()?.available || !this.validateBeforeAddToCart()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true, signal });

      // The native selector is a module; wait for its upgrade before reading its active values.
      customElements.whenDefined('variant-selects').then(() => {
        if (!this.isConnected || signal.aborted) return;
        this.initialize(signal);
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      this.paymentObserver?.disconnect();
      this.buttonObserver?.disconnect();
      this.ready = false;
    }

    initialize(signal) {
      this.ready = true;
      this.addEventListener('click', (event) => this.onClick(event), { signal });
      this.addEventListener('change', (event) => this.onChange(event), { signal });
      this.addEventListener('input', (event) => {
        if (!event.target.matches('.measure-input')) return;
        if (this.isNumberValid(event.target)) event.target.classList.remove('is-invalid');
        this.updatePaymentButtonGuard();
      }, { signal });
      this.addEventListener('blur', (event) => {
        if (!event.target.matches('.measure-input')) return;
        event.target.classList.toggle('is-invalid', !this.isNumberValid(event.target));
        this.setTouched();
        this.updatePaymentButtonGuard();
      }, { capture: true, signal });
      this.form?.querySelector('input[name="id"]')?.addEventListener('change', () => {
        queueMicrotask(() => { if (!signal.aborted) this.syncSelection(); });
      }, { signal });

      this.filterMoreColors();
      this.updateCustomFormUnit();
      this.syncSelection();
      this.sectionRoot?.removeAttribute('data-pv-initializing');

      const checkout = this.sectionRoot?.querySelector('.bls__product-dynamic-checkout');
      if (checkout) {
        this.paymentObserver = new MutationObserver(() => this.updatePaymentButtonGuard());
        this.paymentObserver.observe(checkout, { childList: true, subtree: true });
      }
      const addButton = this.form?.querySelector('.add-cart-button[name="add"]');
      if (addButton) {
        // product-form releases its disabled state after AJAX; an unavailable combination must stay blocked.
        this.buttonObserver = new MutationObserver(() => this.updatePaymentButtonGuard());
        this.buttonObserver.observe(addButton, { attributes: true, attributeFilter: ['disabled'] });
      }
    }

    byId(id) {
      return this.querySelector(`[id="${id}"]`) || this.form?.querySelector(`[id="${id}"]`);
    }

    getSelectedValue(role) {
      return this.native?.querySelector(`fieldset.product-form__input[data-option-role="${role}"] .bls__option-swatch.active`)?.dataset.value || '';
    }

    /* [Modified by Codex at 2026-10-12] 用原生选项确认商品确有尺码，避免将空值当作标准尺码 */
    hasSizeOption() {
      return Boolean(this.native?.querySelector('fieldset.product-form__input[data-option-role="size"]'));
    }
    /* [End] */

    getCurrentVariant() {
      const selected = Array.from(this.native?.querySelectorAll('fieldset.product-form__input[data-option-position]') || [],
        (fieldset) => fieldset.querySelector('.bls__option-swatch.active')?.dataset.value);
      return this.native?.getVariantData().find((variant) =>
        variant.options.length === selected.length && variant.options.every((value, index) => value === selected[index]));
    }

    // [Modified by Codex at 2026-10-26] 精确识别新旧名称以保持定制面板与提交校验一致
    isMoreColor() {
      const value = normalize(this.getSelectedValue('color'));
      return value === 'more color' || value === 'custom color';
    }
    // [End]

    isCustomSize() {
      return normalize(this.getSelectedValue('size')).includes('custom');
    }

    onClick(event) {
      const nativeSwatch = event.target.closest('.bls__option-swatch');
      if (nativeSwatch && nativeSwatch.closest('variant-selects') === this.native) {
        // BLS owns selection, inventory, media, prices and the variant ID. Only read its result.
        const signal = this.abortController.signal;
        queueMicrotask(() => { if (!signal.aborted) this.syncSelection(); });
        return;
      }
      const moreColor = event.target.closest('.color-swatch--more-option');
      if (moreColor && this.isMoreColor()) {
        this.querySelectorAll('.color-swatch--more-option').forEach((button) => button.classList.toggle('active', button === moreColor));
        const name = moreColor.dataset.moreColorName || '';
        const hex = moreColor.dataset.moreColorHex || '';
        const label = this.byId('moreColorSelectedName');
        if (label) label.textContent = name;
        const hidden = this.byId('hidden-more-color');
        if (hidden) {
          hidden.disabled = false;
          hidden.value = `${name} (${hex})`;
        }
        this.updatePaymentButtonGuard();
        return;
      }
      const unit = event.target.closest('.unit[data-unit]');
      if (unit) this.applyUnit(unit.dataset.unit);
      if (event.target.closest('#unitToggle')) this.applyUnit(this.currentUnit === 'in' ? 'cm' : 'in');
      const help = event.target.closest('.measure-help-icon');
      const tip = this.byId('measureTip');
      if (help && tip && FIELD_TIPS[help.dataset.field]) tip.textContent = FIELD_TIPS[help.dataset.field];
    }

    onChange(event) {
      if (event.target.matches('.size-system-radio') && event.target.checked) {
        this.currentSizeSystem = event.target.value;
        if (!this.isCustomSize()) this.renderSizeChart(this.getSelectedValue('size'));
      }
      if (event.target.matches('#customSizeAgree')) this.setTouched();
      if (event.target.matches('#field-extra')) event.target.classList.remove('is-invalid');
      this.updatePaymentButtonGuard();
    }

    setVisible(id, visible) {
      const element = this.byId(id);
      if (element) element.style.display = visible ? 'block' : 'none';
    }

    syncSelection() {
      const size = this.getSelectedValue('size');
      const color = this.getSelectedValue('color');
      /* [Modified by Codex at 2026-10-12] 没有尺码选项时隐藏整个尺码辅助区并清理表格 */
      const hasSize = this.hasSizeOption();
      const isCustom = hasSize && this.isCustomSize();
      this.querySelectorAll('[data-size-extras], .size-chart-controls, .size-help').forEach((element) => {
        element.hidden = !hasSize;
      });
      if (size !== this.lastSize || hasSize !== this.lastHasSize) {
        this.setVisible('sizeChart', hasSize && Boolean(size) && !isCustom);
        this.setVisible('customSizeForm', isCustom);
        this.setVisible('customSizeTipPanel', isCustom);
        if (!isCustom) {
          this.renderSizeChart(size);
          this.byId('customSizeTipPanel')?.classList.remove('custom-size-tip-panel--error');
          this.querySelector('.custom-disclaimer')?.classList.remove('is-invalid');
          const form = this.byId('customSizeForm');
          if (form) form.dataset.touched = '0';
        }
        this.lastSize = size;
        this.lastHasSize = hasSize;
      }
      /* [End] */
      if (color !== this.lastColor) {
        this.setVisible('moreColorPanel', this.isMoreColor());
        if (!this.isMoreColor()) {
          const hidden = this.byId('hidden-more-color');
          if (hidden) { hidden.value = ''; hidden.disabled = true; }
          const label = this.byId('moreColorSelectedName');
          if (label) label.textContent = '';
          this.querySelectorAll('.color-swatch--more-option').forEach((button) => button.classList.remove('active'));
        }
        this.lastColor = color;
      }
      this.updatePaymentButtonGuard();
    }

    filterMoreColors() {
      const values = new Set(Array.from(this.native?.querySelectorAll('[data-option-role="color"] .bls__option-swatch') || [],
        (swatch) => normalize(swatch.dataset.value)));
      this.querySelectorAll('.color-swatch--more-option').forEach((button) => {
        button.hidden = values.has(normalize(button.dataset.moreColorName));
      });
    }

    renderSizeChart(selectedSize) {
      const tbody = this.byId('sizeChartBody');
      if (!tbody) return;
      /* [Modified by Codex at 2026-10-12] 缺少真实尺码时停止回退到默认美国尺码表 */
      if (!this.hasSizeOption() || !selectedSize || this.isCustomSize()) {
        tbody.replaceChildren();
        return;
      }
      /* [End] */
      let index = SIZE_DATA.findIndex((row) => row.size === selectedSize);
      if (index < 0) index = 0;
      const start = Math.max(0, Math.min(index - 1, SIZE_DATA.length - 3));
      const format = (value) => this.currentUnit === 'in' ? `${value} in` : `${Math.round(value * 2.54)} cm`;
      tbody.replaceChildren(...SIZE_DATA.slice(start, start + 3).map((row) => {
        const tr = document.createElement('tr');
        if (row.size === selectedSize) tr.classList.add('active');
        const values = [SIZE_SYSTEM_LABELS[row.size]?.[this.currentSizeSystem] || row.size,
          format(row.bust), format(row.waist), format(row.hips), format(row.hollow)];
        values.forEach((value) => {
          const td = document.createElement('td');
          td.textContent = value;
          tr.appendChild(td);
        });
        return tr;
      }));
    }

    applyUnit(unit) {
      const previous = this.currentUnit;
      this.currentUnit = unit;
      this.querySelectorAll('.unit').forEach((element) => element.classList.toggle('active', element.dataset.unit === unit));
      this.byId('unitSwitch')?.classList.toggle('cm', unit === 'cm');
      if (previous !== unit) {
        MEASURES.forEach((field) => {
          const input = this.byId(`field-${field}`);
          if (!input || !input.value.trim() || !Number.isFinite(parseFloat(input.value))) return;
          const value = parseFloat(input.value);
          input.value = (unit === 'cm' ? value * 2.54 : value / 2.54).toFixed(2);
        });
      }
      if (!this.isCustomSize()) this.renderSizeChart(this.getSelectedValue('size'));
      this.updateCustomFormUnit();
      this.updatePaymentButtonGuard();
    }

    updateCustomFormUnit() {
      this.querySelectorAll('.unit-text').forEach((element) => { element.textContent = this.currentUnit; });
      Object.entries(CUSTOM_RANGES).forEach(([field, range]) => {
        const element = this.byId(`range-${field}`);
        if (!element) return;
        const multiplier = this.currentUnit === 'cm' ? 2.54 : 1;
        element.textContent = `${(range.min * multiplier).toFixed(2)} - ${(range.max * multiplier).toFixed(2)}`;
      });
    }

    isNumberValid(input) {
      return Boolean(input && input.value.trim() && Number.isFinite(parseFloat(input.value)) && parseFloat(input.value) > 0);
    }

    setTouched() {
      const form = this.byId('customSizeForm');
      if (form) form.dataset.touched = '1';
    }

    validateBeforeAddToCart({ silent = false } = {}) {
      const hidden = this.byId('hidden-more-color');
      const moreFail = this.isMoreColor() && !(hidden && !hidden.disabled && hidden.value.trim());
      const hasInvalid = this.isCustomSize() && MEASURES.some((field) => !this.isNumberValid(this.byId(`field-${field}`)));
      const agreed = Boolean(this.byId('customSizeAgree')?.checked);
      const customFail = this.isCustomSize() && (hasInvalid || !agreed);
      const customForm = this.byId('customSizeForm');
      const showCustomError = customFail && (!silent || customForm?.dataset.touched === '1');
      const panel = this.byId('customSizeTipPanel');
      panel?.classList.toggle('custom-size-tip-panel--error', Boolean(showCustomError));
      this.querySelector('.custom-disclaimer')?.classList.toggle('is-invalid', Boolean(showCustomError && !agreed));

      let error = this.byId('more-color-submit-error');
      if (moreFail && !silent) {
        if (!error) {
          error = document.createElement('p');
          error.id = 'more-color-submit-error';
          error.className = 'more-color-submit-error';
          error.setAttribute('role', 'alert');
          const morePanel = this.byId('moreColorPanel');
          morePanel?.before(error);
        }
        error.textContent = MORE_COLOR_MESSAGE;
        error.hidden = false;
        this.setVisible('moreColorPanel', true);
      } else if (error && !moreFail) error.hidden = true;
      if (!silent && customFail) {
        this.setTouched();
        if (panel) panel.textContent = CUSTOM_SIZE_MESSAGE;
        MEASURES.forEach((field) => {
          const input = this.byId(`field-${field}`);
          input?.classList.toggle('is-invalid', !this.isNumberValid(input));
        });
      }
      if (!silent && (moreFail || customFail)) {
        (moreFail ? error : panel || customForm)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return !(moreFail || customFail);
    }

    syncHiddenFields() {
      // [Modified by Codex at 2026-10-26] 让订单颜色属性名称跟随顾客选择的定制入口
      const colorField = this.byId('hidden-more-color');
      if (colorField) {
        const colorName = normalize(this.getSelectedValue('color')) === 'custom color' ? 'Custom Color' : 'More Color';
        colorField.name = `properties[${colorName}]`;
      }
      // [End]
      const custom = this.isCustomSize();
      [...MEASURES, 'extra'].forEach((field) => {
        const hidden = this.byId(`hidden-${field}`);
        if (!hidden) return;
        hidden.disabled = !custom;
        const value = this.byId(`field-${field}`)?.value || '';
        hidden.value = !custom ? '' : field === 'extra' ? value || '0' : value ? `${value}${this.currentUnit}` : '';
      });
    }

    updatePaymentButtonGuard() {
      if (!this.isConnected || !this.ready) return;
      this.syncHiddenFields();
      const available = Boolean(this.getCurrentVariant()?.available);
      const valid = this.validateBeforeAddToCart({ silent: true }) && available;
      const checkout = this.sectionRoot?.querySelector('.bls__product-dynamic-checkout');
      if (checkout) {
        checkout.classList.toggle('pv-payment-guarded', !valid);
        checkout.setAttribute('aria-disabled', valid ? 'false' : 'true');
        checkout.inert = !valid;
      }
      const addButton = this.form?.querySelector('.add-cart-button[name="add"]');
      if (!available && addButton && !addButton.disabled) addButton.disabled = true;
    }
  }

  if (!customElements.get('product-variant-extras')) customElements.define('product-variant-extras', ProductVariantExtras);
  const releaseSectionsWithoutPicker = () => {
    document.querySelectorAll('.bls__template-product[data-pv-initializing]').forEach((section) => {
      if (!section.querySelector('product-variant-extras')) section.removeAttribute('data-pv-initializing');
    });
  };
  releaseSectionsWithoutPicker();
  document.addEventListener('shopify:section:load', releaseSectionsWithoutPicker);
})();
/* [End] */
